import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';

import { spacing, colors } from '../../../styles/theme';
import BaseButton from '../../ui/Button';
import BaseLogo from '../Logo';

export const Container = styled.div`
  width: 70%;
  margin: auto;
`;

export const Form = styled.form`
  margin-top: 16px;
  width: 100%;

  button {
    margin: ${spacing('4')} 0 ${spacing('2')} 0;
  }

  div + div {
    margin-top: ${spacing('4')} !important;
  }
`;

export const Button = styled(BaseButton)`
  display: block;
  margin: ${spacing('4')} auto;
  padding: ${spacing('2')} ${spacing('8')};
  background-color: ${colors('accent.base')};
  color: ${colors('white.base')};
  width: 100%;

  &:hover {
    background-color: ${colors('white.base')};
    color: ${colors('accent.base')};
    border: 1px solid ${colors('accent.base')};
  }
`;

export const Logo = styled(BaseLogo)`
  margin: 0 auto ${spacing('3')} auto;
`;

export const TitleContainer = styled.div`
  margin-bottom: ${spacing('1')};

  & + & {
    margin-top: ${spacing('4')};
  }

  p + p {
    margin-top: ${spacing('1')};
  }
`;

export const Link = styled(LinkRouter)`
  color: ${colors('primary.base')};
  text-decoration: none;
`;
